import { render, staticRenderFns } from "./addRequired.vue?vue&type=template&id=1d899204&scoped=true"
import script from "./addRequired.vue?vue&type=script&lang=js"
export * from "./addRequired.vue?vue&type=script&lang=js"
import style0 from "./addRequired.vue?vue&type=style&index=0&id=1d899204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d899204",
  null
  
)

export default component.exports